import React from 'react';
// import PropTypes from 'prop-types';
import { graphql, withApollo } from 'react-apollo';
import getExpedientePorId from '../../../../graphql/querys/contravenciones/getExpedientePorId.graphql';
import subirActuacion from '../../../../graphql/mutations/contravenciones/subirActuacion.graphql';
import { Upload, Row, Col, Spin, Button, Input, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsExpedientes from '../../../../actions/expediente';
import * as actionsContraventores from '../../../../actions/contraventores';
import * as actionsMain from '../../../../actions/main';

@graphql(subirActuacion, {
  name: 'subirActuacion',
  options: {
    refetchQueries: [
      {
        query: getExpedientePorId,
        options: props => ({
          variables: {
            _id: props.expediente._id,
          },
          fetchPolicy: 'network-only',
          onCompleted: data => {
            // console.log('HOLA 2');
            props.actionsExpedientes.setExpediente(data.getExpedientePorId);
            // console.log('Estoy en...');
            // console.log(data);
            if (data.getExpedientePorId) {
              props.actionsContraventores.agregarContraventores(
                data.getExpedientePorId.contraventores
              );
            }
            // console.log('CHAU');
          },
          onError: data => {
            console.log('ERROR: ', data);
            console.log(props);
          },
        }),
      },
    ],
  },
})
class Uploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      titulo: '',
      uploading: false,
    };
  }

  guardarActuacionEnServer = file => {
    this.props
      .subirActuacion({
        variables: {
          objActuacion: {
            nombre: this.state.titulo,
            tipo: 'DOCUMENTO DIGITAL',
            idExpediente: this.props.expediente._id,
          },
          archivo: file,
        },
      })
      .then(res => {
        if (res.data.subirActuacion) {
          this.props.actionsExpedientes.agregarActuacion(
            res.data.subirActuacion
          );
          this.props.ocultar();
          notification.success({
            message: 'Documento agregado correctamente',
            description:
              'El documento se registró correctamente en la base de datos',
          });
        }
      })
      .catch(err => {
        console.log('ERROR EN INSERTAR ACTUACION: ', err);

        notification.error({
          message: 'Error al agregar el documento',
          description: 'Se ha producido un error al agregar el documento',
        });
      });
  };

  handleUpload() {
    const { fileList } = this.state;
    if (!fileList.length) return;

    if (this.state.titulo.length > 0) {
      let all = fileList.map(file => this.guardarActuacionEnServer(file));
      // eslint-disable-next-line no-unused-vars
      Promise.all(all).then(res => {
        this.setState({ uploading: false, fileList: [] });
        if (this.props.onDone) this.props.onDone(all);
      });
      this.setState({ uploading: true });
    } else {
      notification.warning({
        message: 'Debe incluir un titulo al archivo PDF',
      });
    }
  }

  render() {
    const uploadProps = {
      action: this.props.action || this.state.uploadData,
      // data: this.state.uploadData.formData,
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file],
        }));
        return false;
      },
      fileList: this.state.fileList,
      accept: 'application/pdf',
    };

    return (
      <Form encType="multipart/form-data">
        <Row>
          <Col span={24}>
            <div className="inputs">
              <h3>Titulo: </h3>
              <Input
                id="titulo"
                value={this.state.titulo}
                placeholder="Ingrese el titulo del documento a subir"
                onChange={e =>
                  this.setState({
                    titulo: e.target.value,
                  })
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Upload {...uploadProps}>
              <Button>
                <Icons.UploadOutlined />
                Seleccionar Documento PDF
              </Button>
            </Upload>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <br />
            {this.state.uploading && <Spin tip="Subiendo..." />}
            {!this.state.uploading && this.state.fileList.length > 0 && (
              <Button
                icon={<Icons.UploadOutlined />}
                onClick={this.handleUpload.bind(this)}
                style={{ width: '20em' }}
                type="primary"
              >
                Subir
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  actionsExpedientes: bindActionCreators(actionsExpedientes, dispatch),
  actionsContraventores: bindActionCreators(actionsContraventores, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(Uploader));
